import { useTheme } from 'styled-components';
import { DarkTheme } from 'styles/themes/dark';
import { ThemeType } from 'styles/themes/KCFTheme';
import { LightTheme } from 'styles/themes/light';

// Re-export all theme properties
export * from './themeProperties';

/**
 * Lookup object containing all of the theme values for every theme.
 */
const themeValues: Record<ThemeType, typeof LightTheme> = {
    light: LightTheme,
    dark: DarkTheme,
};

/**
 * Returns all of the theme values for the current theme.
 * @example
 * ```ts
 * const { backgroundColor, primaryText } = useThemeValues();
 * ```
 */
export function useThemeValues(): typeof LightTheme {
    const { colorMode } = useTheme() as { colorMode: ThemeType };
    return themeValues[colorMode];
}

export function useColorMode() {
    const { colorMode } = useTheme() as { colorMode: ThemeType };
    return colorMode;
}
